export default class gTagEvents {

    constructor() {
        this.notificationBell = document.querySelectorAll('.notification_bell');
        this.storyThumb = document.querySelectorAll('.story_thumb');
        this.shopLogo = document.querySelectorAll('.shop_logo');

        // Is the element present on the current page
        if (this.notificationBell) {
            /** Notification bell events */
                for (let i = 0; i < this.notificationBell.length; i++) {
                    this.notificationBell[i].addEventListener('click', () => {
                        this.notifyBell();
                    });
                }
        }
        // Is the element present on the current page
        if (this.storyThumb ) {
            /** Notification story events */
            for (let i = 0; i < this.storyThumb .length; i++) {
                const storySlug = this.storyThumb[i].dataset.storylug;
                this.storyThumb[i].addEventListener('click', () => {
                    this.storyEvent(storySlug);
                });
            }
        }
        // Is the element present on the current page
        if (this.shopLogo ) {
            /** Notification shop logos events */
            for (let i = 0; i < this.shopLogo .length; i++) {
                const logoEvent = this.shopLogo[i].dataset.id;
                this.shopLogo[i].addEventListener('click', () => {
                    this.shopLogos(logoEvent);
                });
            }
        }


    }

    notifyBell() {
        dataLayer.push({
            'event': 'notification_bell'
        });
    }
    storyEvent(name) {
        dataLayer.push({
            'product': name,
            'event': 'story_opened'
        });
    }
    shopLogos(name) {
        dataLayer.push({
            'shop': name,
            'event': 'shop_click'
        });
    }
}
